/* eslint-disable react/jsx-pascal-case */
import React, {ReactElement} from "react"
import Styles from "./index.less"
import {connect} from "react-redux"
import Operate from "../operate/operate"
import Display from "../display/display"
import PopupWindow from "../popupWindow/popup"
import {ReducerState} from "../../reducer/interface/baseInterface"
const Index = (props: ReducerState) => {
    const renderIndex = () => {
        switch (props.control.activeView) {
            case "operate":
                return <Operate />
            case "display":
                return <Display />
            default:
                return null
        }
    }
    const renderErrorLog = () => {
        if (props.control.showErrorLog) {
            return <PopupWindow type={props.data.errorLog.type} data={props.data.errorLog.data} />
        } else {
            return null
        }
    }
    return (
        <div id={"ocr_tda"} className={Styles.TDA}>
            {renderErrorLog()}
            {renderIndex()}
        </div>
    )
}

export default connect((state) => state)(Index)
